export const data = [
  {
    origin_city: "Bangalore",
    destination_city: "Mumbai",
    total_quantity: 6501,
    sla: 0.229503153361021,
    total_value: "6.76 K"
  },
  {
    origin_city: "Mumbai",
    destination_city: "Bangalore",
    total_quantity: 5836,
    sla: 0.278958190541467,
    total_value: "5.96 K"
  },
  {
    origin_city: "Bangalore",
    destination_city: "Bangalore",
    total_quantity: 5578,
    sla: 0.284331301541771,
    total_value: "5.56 K"
  },
  {
    origin_city: "Lucknow",
    destination_city: "Mumbai",
    total_quantity: 5139,
    sla: 0.302004280988519,
    total_value: "5.17 K"
  },
  {
    origin_city: "Bangalore",
    destination_city: "Lucknow",
    total_quantity: 6449,
    sla: 0.304388277252287,
    total_value: "6.12 K"
  },
  {
    origin_city: "Mumbai",
    destination_city: "Mumbai",
    total_quantity: 5539,
    sla: 0.315219353673948,
    total_value: "5.08 K"
  }
];
export const displayedColumns = ["pairs", "sla", "value", "quantity"];
